export const Category = ['Σταθερός Η/Υ', 'Laptop' , 'Κινητό', 'Tablet', 'Εκτυπωτής', 'Game Console'];